// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-periods--table .services-periods--span[data-v-0b589512]{opacity:.4}.active-period .services-periods--span[data-v-0b589512]{opacity:unset;font-weight:700}.wrong-date-format .services-periods--span[data-v-0b589512]{color:red;text-decoration:line-through}", ""]);
// Exports
module.exports = exports;
